<template>
  <div>
    <div class="nav flex">
      <div class="center flex">
        <div class="nav-text flex">
          <img src="/static/images/laba.svg" alt="" />
          <!-- <svg data-v-248913c8="" data-v-62120d86="" aria-hidden="true" class="svg-icon"><use data-v-248913c8="" xlink:href="#icon-icon-horn"></use></svg> -->
          <div class="logo-title">
            <el-carousel height="40px" direction="vertical" :interval="5000">
              <el-carousel-item v-for="(item, index) in notice" :key="index">
                <h3 class="medium">{{ item.name }}</h3>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
        <div class="nav-reg flex">
          <div class="yidong">
              <el-popover placement="bottom" trigger="hover">
                  <div class="applet" style="padding-top: 10px;">
                      <div class="qrCode">
                          <img src="/static/images/mbewm.png" alt="">  
                      </div>
                      <p class="text flex">
                          <img src="/static/images/mbewm_icon.png" alt="">
                          抢单！发货！随时随地
                      </p>
                  </div>
                  <!-- <div class="text2" slot="reference">无仓移动版</div> -->
              </el-popover>
          </div>
          <div class="com">
            <el-dropdown trigger="click" placement="bottom" @command="handleCommand">
              <span class="el-dropdown-link">
                {{ username }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <!-- <el-dropdown-item>个人公司</el-dropdown-item>
                <el-dropdown-item>订单</el-dropdown-item> -->
                <el-dropdown-item command="xgpassword">修改密码</el-dropdown-item>
                <el-dropdown-item command="logout">退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
    </div>
    <div class="dd flex">
        <div class="lefts">
          <img src="/static/images/logos.png" alt="" />
          <!-- <img src="/static/images/logo2.jpg" alt="" /> -->
        </div>
        <div class="rights flex" @click="order">
          <ul>
            <div class="top">
              <li class="flex">
                <p>{{ tab_stats.today_win }}</p>
                <span>当日已中标</span>
              </li>
              <li class="flex">
                <p>{{ tab_stats.pending }}</p>
                <span>待发货</span>
              </li>
              <li class="flex">
                <p>{{ tab_stats.ontheway }}</p>
                <span>未到货</span>
              </li>
              <!-- <li class="flex">
                <p>0</p>
                <span>应开发票</span>
              </li> -->
            </div>
            <div class="bo">
              <li class="flex">
                <p>{{ tab_stats.arrived }}</p>
                <span>已到货</span>
              </li>
              <li class="flex">
                <p>{{ tab_stats.partial }}</p>
                <span>部分到货</span>
              </li>
              <li class="flex">
                <p>{{ tab_stats.all }}</p>
                <span>全部订单</span>
              </li>
              <!-- <li class="flex">
                <p>0</p>
                <span>当日发货</span>
              </li>
              <li class="flex">
                <p>0</p>
                <span>在途</span>
              </li> -->
              <!-- <li class="flex">
                <p>0</p>
                <span>合同管理</span>
              </li> -->
            </div>
          </ul>
          <div class="chakan">查看 ></div>
        </div>
    </div>
    <!-- 发货弹窗 -->
    <div class="xgtDialog">
        <el-dialog title="修改密码" :visible.sync="dialogFormVisible" width="400px" @close="closeXg">
            <el-form>
                <el-form-item label="新密码" :label-width="formLabelWidth">
                    <el-input v-model="password" @input="changeXg" autocomplete="off" placeholder="请填写新密码"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="xgCancel">取 消</el-button>
                <el-button type="primary" @click="xgSure">确 定</el-button>
            </div>
        </el-dialog>
    </div>
  </div>
</template>

  <script>
  import { user, logout, getGrabBrand, myOrderList, changePassword } from "@/api";
  export default {
    data() {
      return {
        // 修改密码
        dialogFormVisible: false,
        password: '',
        // 订单状态数量
        tab_stats: {
          all: 0,
          arrived: 0,
          ontheway: 0,
          partial: 0,
          pending: 0,
          today_win: 0
        },
        username: '', // 账户名称
          // 公告
          notice: [
            {
              id: 1,
              name: '各位老板: O2O订单是从电商平台成交后，自动上传抢单的，平台每天7点开始会发布当天新的订单。大家可以预约抢单，9点半部分品牌开始倒计时，谢谢！'
            },
            {
              id: 2,
              name: '郑重声明：提供虚假运单号造成的一切线上纠纷后果请自行承担，如有发现扣除50元保证金，并暂缓货款结算！！！'
            },
            {
              id: 3,
              name: '各位老板: O2O订单是从电商平台成交后，自动上传抢单的，平台每天7点开始会发布当天新的订单。大家可以预约抢单，9点半部分品牌开始倒计时，谢谢！'
            }
          ],
          account: '',
          isReg: false,
      };
    },
    methods: {
      // 订单
      myOrderListss(){
          // this.loading = true;
          myOrderList({
              tab: '',
              date: '',
              delivery_date: '',
              // page: this.page,
              // limit: this.limit
          }).then((res) => {
              console.log(res);
              this.loading = false;
              if (res.data.code == 1) {
                this.tab_stats = res.data.data.tab_stats;
              }
          });
      },
      // 获取品牌用于登录是否时效
      getGrabBrand() {
          getGrabBrand({}).then((res) => {
              // console.log(res.data.data);
              if (res.data.code !== 1) {
                  // this.$message.error('请先登录账户');
                  this.$router.replace("/login")
              }
          });
      },
      // 订单跳转
      order(){
        this.$router.replace("/order")
      },
      handleCommand(command) {
        if(command == 'logout'){
          // this.$message.error('点击了退出登录');
          this.logout();
        }
        if(command == 'xgpassword'){
          // this.$message.error('点击了修改密码');
          this.dialogFormVisible = true
        }
      },
      // 关闭弹窗回调
      closeXg(){
          this.password = ''
      },
      xgCancel(){
          this.dialogFormVisible = false,
          this.password = ''
      },
      changeXg(val){
          this.password = val
          // console.log(val)
      },
      xgSure(){
        if (this.password === ''){
            this.$message.error('请填写新密码');
            return
        }else{
            // console.log('自送')
            this.dialogFormVisible = false;
            this.changePassword(this.password)
        }
    },
      // 修改密码
      changePassword(val){
        changePassword({
          password: val
        }).then((res) => {
            // console.log(res);
            // this.loading = false;
            if (res.data.code == 1) {
              this.$message.success(res.data.msg);
              localStorage.removeItem('token');
              localStorage.removeItem('username');
              this.$router.replace("/login")
            } else {
              this.$message.error(res.data.msg);
            }
        });
      },
      // 退出登录
      logout(){
        logout({}).then((res) => {
            // console.log(res);
            // this.loading = false;
            if (res.data.code == 1) {
              // localStorage.removeItem("token");
              // localStorage.removeItem("username");
              this.$message({
                message: '退出成功，请重新登录',
                type: 'success'
              });
              this.$router.replace("/login")
            } else {
              this.$message.error(res.data.msg);
            }
        });
      }
    },
    created() {
      this.myOrderListss(); // 获取订单
      this.getGrabBrand(); // 获取品牌
      let token = localStorage.getItem('token');
      let username = localStorage.getItem('username');
      let batoken = JSON.parse(token);
      console.log(username)
      if (batoken == '' || batoken == null) {
          this.$message.error('请先登录账户');
          this.$router.replace("/login")
      }else{
          this.username = JSON.parse(username)
      }
    },
  };
</script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
</style>
  


// WEBPACK FOOTER //
// src/components/common/header.vue